module.exports = __webpack_public_path__ + "img/IconAdmin2.1958e59a.png";